<template>
  <div>
    <!-- 采购联系人 -->
    <Modal :value="contactVisible" title="联系人" :transfer="false" @on-visible-change="contactVisibleChange">
      <Button size="small" type="primary" @click="contactDetailVisible=true" style="margin-bottom:5px;">添加</Button>
      <Table :columns="editContactColumns" :data="editContactData"></Table>
      <div slot="footer">
        <Button @click="contactVisibleChange(false)">取消</Button>
        <Button type="primary" @click="confirmContact">确定</Button>
      </div>
    </Modal>
    <!-- 联系人编辑 -->
    <Modal v-model="contactDetailVisible" title="编辑联系人信息" :transfer="false" @on-visible-change="editContactChange">
      <div>
        <Form :label-width="90" ref="contactForm" :model="contactInfo" :rules="contactValid">
          <FormItem label="联系人姓名" prop="name">
            <Input type="text" v-model="contactInfo.name"></Input>
          </FormItem>
          <FormItem label="手机号码" prop="phone">
            <Input type="text" v-model="contactInfo.phone"></Input>
          </FormItem>
          <FormItem label="座机" prop="telephone">
            <Input type="text" v-model="contactInfo.telephone"></Input>
          </FormItem>
          <FormItem label="职位">
            <Input type="text" v-model="contactInfo.position"></Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button @click="contactDetailVisible=false">取消</Button>
        <Button type="primary" @click="confirmEditContact">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import axios from 'axios'
import requestUrls from '@/lib/eRequestUrls'

export default {
  name: 'ecitContact',
  props: {
    contactVisible: {
      type: Boolean,
      default: false
    },
    originContactArr: {
      type: Array,
      default() {
        return []
      }
    },
    cgrid: {
      required: true,
    }
  },
  data() {
    return {
      editContactColumns: [
        {
          title: '联系人',
          key: '联系人'
        },
        {
          title: '联系方式',
          key: '联系方式'
        },
        {
          title: '操作',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editContact(params)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.delContact(params)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      editContactData: [],
      contactInfo: {
        name: '',
        phone: '',
        telephone: '',
        position: ''
      },
      contactValid: {
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          { type: 'string', pattern: /^1[3456789]\d{9}$/, message: '请检查您输入的手机号码', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: '座机不能为空', trigger: 'blur' },
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '请检查您输入的号码，(格式：000-1234567,15525252525)', trigger: 'blur' }
        ]
      },
      contactDetailVisible: false,
      editContactIndex: ''
    }
  },
  methods: {
    confirmEditContact() {
      this.$refs.contactForm.validate(valid => {
        if (valid) {
          if (parseInt(this.editContactIndex) >= 0) {
            this.$set(this.editContactData, this.editContactIndex, {
              '联系人': this.contactInfo.name,
              '联系方式': this.contactInfo.phone,
              '座机号码': this.contactInfo.telephone,
              '职位': this.contactInfo.position
            })
          } else {
            this.editContactData.push({
              '联系人': this.contactInfo.name,
              '联系方式': this.contactInfo.phone,
              '座机号码': this.contactInfo.telephone,
              '职位': this.contactInfo.position
            })
          }
          // console.log(this.editContactData)
          this.contactDetailVisible = false
        }
      })
    },
    editContact(params) {
      this.editContactIndex = params.index
      this.contactInfo = {
        name: params.row['联系人'],
        phone: params.row['联系方式'],
        telephone: params.row['座机号码'],
        position: params.row['职位']
      }
      this.contactDetailVisible = true
    },
    delContact(params) {
      this.$Modal.confirm({
        title: '删除联系人',
        content: '确定删除此联系人？',
        onOk: () => {
          this.editContactData.splice(params.index, 1)
        }
      })
    },
    contactVisibleChange(val) {
      if (val) {
        // 复制数据
        this.editContactData = JSON.parse(JSON.stringify(this.originContactArr))
      } else {
        this.$emit('cancel')
      }
    },
    editContactChange(val) {
      if (!val) {
        // 清空填写信息
        this.editContactIndex = ''
        this.contactInfo = {
          name: '',
          phone: ''
        }
      }
    },
    async confirmContact() {
      let contact = await ajax.get(`${requestUrls.ClPurchase.GetById}?id=${this.cgrid}`)
      let obj = contact.data.result
      obj.contactPersonOrWay = JSON.stringify(this.editContactData).slice(1, -1)
      // console.log(this.editContactData)
      // console.log(this.contactInfo)
      // let rep = await axios.get('http://14.116.193.123:8090/fr/cailian/updateContactById', {
      //   params: {
      //     id: this.cgrid,
      //     contact: contact
      //   }
      // })
      let rep = await ajax.post(requestUrls.ClPurchase.CreateOrUpdate,{
        "clPurchase": obj
      })
      this.$emit('finish', this.editContactData)
    }
  }
}
</script>
